module.exports = __webpack_public_path__ + "static/media/info-alert.1d7dd09c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/info-alert.svg
// module id = 239
// module chunks = 7